export var RESOURCE_TYPE = {
  ACCOUNT_SUB_TYPE: 'ACCOUNT_SUB_TYPE',
  ACCOUNT_TYPE: 'ACCOUNT_TYPE',
  APPOINTMENT: 'APPOINTMENT_ID',
  CAMPAIGN: 'CAMPAIGN',
  CONTROL_TYPE: 'CONTROL_TYPE',
  COUPON: 'COUPON',
  CUSTOMER: 'CUSTOMER',
  CUSTOMER_MINIMAL: 'CUSTOMER_MINIMAL_SEARCH',
  DEALER: 'DEALER',
  FEE: 'FEE',
  DEALER_USER: 'DEALER_USER',
  DELAERPART: 'DELAERPART',
  DEPARTMENT: 'DEPARTMENT',
  DOCUMENT_TYPE: 'DOCUMENT_TYPE',
  ESTIMATE: 'ESTIMATE_ID',
  FRANCHISE: 'FRANCHISE',
  GLACCOUNT: 'ACCOUNT_ID',
  JOURNAL_ID: 'JOURNAL_ID',
  JOURNAL_TYPE: 'JOURNAL_TYPE',
  JOURNAL_ASSET: 'JOURNAL_ASSET',
  LEAD_BY_ID: 'LEAD_BY_ID',
  PART_KIT: 'PART_KIT_ID',
  PART: 'PART',
  PARTANDINVENTORY: 'PARTANDINVENTORY',
  PARTINVENTORY: 'PARTINVENTORY',
  PARTMASTER: 'PARTMASTER',
  USER_ID: 'DSE_USER',
  VEHICLE: 'VEHICLES_BY_ID',
  DESCRIPTIVE_VEHICLE: 'VEHICLES_BY_ID',
  VEHICLE_VIN: 'VEHICLES_BY_VIN',
  VENDOR: 'VENDOR',
  PAY_DEPARTMENT: 'PAY_DEPARTMENT',
  PAY_TYPE: 'PAY_TYPE',
  OPCODE: 'OPCODE',
  PAYMENT_METHOD: 'PAYMENT_METHOD',
  REF_TYPE: 'REF_TYPE',
  REPAIR_ORDER_ASSET: 'REPAIR_ORDER_ASSET',
  TICKET: 'TICKET',
  SERVICE_TYPE: 'SERVICE_TYPE',
  PARTSALES: 'PARTSALES',
  FEEV2: 'FEEV2',
  REF_ID: 'REF_ID',
  PART_PRICE_CODE: 'PARTPRICECODE',
  PO_INVOICE_ASSET: 'PO_INVOICE_ASSET',
  GMLABOROPCODE: 'GMLABOROPCODE',
  GL_ACCOUNT_ASSET: 'GL_ACCOUNT_ASSET',
  PARTSOURCECODE: 'PARTSOURCECODE',
  BINS: 'BINS',
  SHELVES: 'SHELVES',
  DRAWERS: 'DRAWERS',
  PARTPO: 'PARTPO',
  DEAL_VEHICLE: 'DEALS_BY_VEHICLEID',
  DEALS: 'DEALS_BY_DEALNUMBER',
  TENANT_USER_MINIMAL: 'TENANT_USER_MINIMAL',
  DEALER_ACCESSIBLE_USER_MINIMAL: 'DEALER_ACCESSIBLE_USER_MINIMALV2',
  DEALER_ACCESSIBLE_USER_MINIMALV3: 'DEALER_ACCESSIBLE_USER_MINIMALV3',
  DEALER_ACCESSIBLE_USER_MINIMAL_DEPRECATED: 'DEALER_ACCESSIBLE_USER_MINIMAL',
  PART_INVOICE: 'PART_INVOICE',
  VIN_LAST_8: 'VEHICLES_BY_LAST_8_VIN',
  VEHICLE_INTERIOR_COLOR: 'VEHICLE_INTERIOR_COLOR',
  VEHICLE_EXTERIOR_COLOR: 'VEHICLE_EXTERIOR_COLOR',
  VEHICLE_EXTERIOR_COLOR_HEXCODE: 'VEHICLE_EXTERIOR_COLOR_HEXCODE',
  ACCOUNTS_COST_CENTER: 'ACCOUNTS_COST_CENTER',
  // lookup all
  TAG_BY_NAME: 'TAG_BY_NAME',
  DEAL_TAX_COUNTY: 'DEAL_TAX_COUNTY',
  DEAL_TAX_STATE: 'DEAL_TAX_STATE',
  DEAL_TAX_CITY: 'DEAL_TAX_CITY',
  EMPLOYEE: 'EMPLOYEE',
  DEAL_CUSTOMER_COUNTY: 'DEAL_CUSTOMER_COUNTY',
  DEAL_CUSTOMER_CITY: 'DEAL_CUSTOMER_CITY',
  DEAL_CUSTOMER_STATE: 'DEAL_CUSTOMER_STATE',
  SERVICE_TENANT_USER_MINIMAL: 'SERVICE_TENANT_USER_MINIMAL'
};